import * as LabelPrimitive from '@radix-ui/react-label';
import { forwardRef } from 'react';

import { cn } from './cn';

/**
 * A form label.
 *
 * Radix's Label rather than a bare `<label>` for one behaviour: it suppresses
 * the text selection a double-click on a label otherwise causes, which on a
 * dense form (the attendance grid, the invoice composer) turns an ordinary
 * mis-click into a page full of highlighted text.
 *
 * `peer-disabled:` dims the label when the control it names is disabled, so a
 * disabled field reads as one unit instead of a live label over a dead input.
 */
export const Label = forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(function Label({ className, ...rest }, ref) {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        'inline-flex items-center gap-2',
        'text-[length:var(--text-xs)] font-medium leading-[var(--leading-snug)]',
        'text-[color:var(--text-tertiary)]',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-60',
        className,
      )}
      {...rest}
    />
  );
});
